import { faro } from '@grafana/faro-react'

export interface FaroClassroomContext {
    userId: string
    classId?: string
    role?: string
}

const isFaroEnabled = (): boolean => {
    return Boolean(process.env.REACT_APP_FARO_URL && faro.api)
}

let lastSyncedContext: string | null = null

export const syncFaroClassroomContext = (context: FaroClassroomContext): void => {
    if (!isFaroEnabled()) {
        return
    }

    const { userId, classId, role } = context

    const contextKey = `${userId}:${classId ?? ''}:${role ?? ''}`
    if (lastSyncedContext === contextKey) {
        return
    }
    lastSyncedContext = contextKey

    faro.api?.setUser({
        id: userId,
        attributes: {
            ...(classId ? { classId } : {}),
            ...(role ? { role } : {})
        }
    })

    const current = faro.api?.getSession?.()
    if (current?.id) {
        faro.api?.setSession?.({
            id: current.id,
            attributes: {
                ...(classId && { classId }),
                ...(role && { role })
            }
        })
    }

    if (userId && classId && role && faro.api?.pushEvent) {
        faro.api.pushEvent('classroom_context_set', {
            userId,
            classId,
            role
        })
    }
}

export const clearFaroClassroomContext = (): void => {
    if (!isFaroEnabled()) {
        return
    }

    lastSyncedContext = null

    faro.api?.setUser(undefined)

    const current = faro.api?.getSession?.()
    if (current?.id && current?.attributes) {
        const { classId, role, ...remainingAttributes } = current.attributes
        faro.api?.setSession?.({
            id: current.id,
            attributes: remainingAttributes
        })
    }
}

export const setFaroView = (pathname: string): void => {
    if (!isFaroEnabled()) return
    const name = pathname.startsWith('/autologin') ? '/autologin/*' : pathname
    faro.api?.setView?.({ name })
}

export const syncFaroClassroomContextFromStorage = (): boolean => {
    if (typeof sessionStorage === 'undefined') {
        return false
    }

    const userId = sessionStorage.getItem('userId')
    if (!userId) {
        return false
    }

    syncFaroClassroomContext({
        userId,
        classId: sessionStorage.getItem('classroomId') ?? undefined,
        role: sessionStorage.getItem('role') ?? undefined
    })

    return true
}
